// Função para padronizar o preenchimento com zero
const padZero = (num) => String(num).padStart(2, '0')

// Função para converter um valor para inteiro
const safeParseInt = (valor) => {
  const num = parseInt(valor, 10)
  return Number.isNaN(num) ? 0 : num
}

// Função para formatar data/hora no formato brasileiro
const dateTimeSqlToDateTimeBR = (value) => {
  if (!value) return value

  const date = new Date(value)
  return date.toLocaleDateString('pt-BR', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
  })
}

// Função para converter data ISO para data no formato brasileiro
const dateISOToDateBR = (isoDate) => {
  if (!isoDate) return isoDate

  const date = new Date(isoDate)

  const dia = String(date.getDate()).padStart(2, '0')
  const mes = String(date.getMonth() + 1).padStart(2, '0')
  const ano = date.getFullYear()

  return `${dia}/${mes}/${ano}`
}

// Função para converter timestamp para data no formato brasileiro
const convertTimestampToBrazilianDate = (timestamp, withTime = true) => {
  if (!timestamp) return timestamp

  const date = new Date(timestamp * 1000) // Convertendo de segundos para milissegundos
  const day = padZero(date.getDate())
  const month = padZero(date.getMonth() + 1) // Meses começam do 0
  const year = date.getFullYear()
  const hours = padZero(date.getHours())
  const minutes = padZero(date.getMinutes())
  const seconds = padZero(date.getSeconds())

  if (!withTime) return `${day}/${month}/${year}`
  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`
}

// Função para converter segundos em horas
const convertSecondsToHours = (totalSeconds) => {
  if (totalSeconds === undefined || totalSeconds === null) return '00:00:00'

  const isNegative = totalSeconds < 0
  const absSeconds = Math.abs(totalSeconds)

  const hours = Math.floor(absSeconds / 3600)
  const minutes = Math.floor((absSeconds % 3600) / 60)
  const seconds = absSeconds % 60

  // Formatação de horas, minutos e segundos
  const formattedHours = hours < 10 ? `0${hours}` : hours
  const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes
  const formattedSeconds = seconds < 10 ? `0${seconds}` : seconds

  // Retorna a hora no formato hh:mm:ss
  const timeString = `${formattedHours}:${formattedMinutes}:${formattedSeconds}`
  return isNegative ? `-${timeString}` : timeString
}

// Função para converter horas em segundos
const convertHoursToSeconds = (hours = 0, minutes = 0, seconds = 0) => {
  return (
    safeParseInt(hours) * 3600 +
    safeParseInt(minutes) * 60 +
    safeParseInt(seconds)
  )
}

// Função para converter segundos totais em horas, minutos e segundos separados
const parseTimeFromSeconds = (totalSeconds) => {
  // Verifica se o valor é indefinido ou nulo. Se for, retorna tudo zerado.
  if (totalSeconds === undefined || totalSeconds === null) {
    return { hours: 0, minutes: 0, seconds: 0 }
  }

  // Converte os segundos em uma string no formato hh:mm:ss
  const time = convertSecondsToHours(totalSeconds)

  // Divide a string em um array e converte os valores para número
  const times = time.split(':').map(Number)

  // Desestrutura o array para obter horas, minutos e segundos
  const [hours, minutes, seconds] = times

  // Retorna os valores como um objeto
  return {
    hours,
    minutes,
    seconds,
  }
}

const getYearMonthCurrent = (date = new Date()) => {
  const month = [
    'Janeiro',
    'Fevereiro',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro',
  ]

  const year = date.getFullYear()
  const monthNumber = date.getMonth() + 1
  const monthName = month[date.getMonth()]

  return { year, monthNumber, monthName }
}

export {
  dateTimeSqlToDateTimeBR,
  dateISOToDateBR,
  convertTimestampToBrazilianDate,
  convertSecondsToHours,
  convertHoursToSeconds,
  parseTimeFromSeconds,
  getYearMonthCurrent,
}
